import React from "react";
import "./App.css";
import { Routes } from "./routes/Routes";

function App() {
  return (
    <div className="app">
      <Routes />
    </div>
  );
}

export default App;
